import getDefaultLocalePath from './getDefaultLocalePath';

export default function isDefaultLocalePath(locale: string) {
  return getDefaultLocalePath() === locale;
}
